module.exports = __webpack_public_path__ + "static/media/email.361d90e0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/email.svg
// module id = 32
// module chunks = 0